import { useWithUserAndTenant } from "cp-client-auth!sofe";
import { useEffect, useState } from "react";

import { handleError } from "src/error";

import { postAnalytic } from "src/onboarding/resources.js";

export const EXITED = "ftl_page_aborted";
export const SKIPPED = "ftl_page_skipped";
export const COMPLETED = "ftl_completed";

export function useUnloadEvent(payload, event) {
  const [user, tenant] = useWithUserAndTenant();
  useEffect(() => {
    let subscription$;
    const subscribeAnalytic = () => {
      subscription$ = postAnalytic(
        {
          data: payload,
          event_date: Date.now(),
          tenant_id: tenant.id,
          user_id: user.id,
        },
        event
      ).subscribe((_) => {}, handleError);
    };

    window.addEventListener("beforeunload", subscribeAnalytic);

    return () => {
      window.removeEventListener("beforeunload", subscribeAnalytic);
      subscription$ && subscription$.unsubscribe();
    };
  }, [payload, event]); // eslint-disable-line react-hooks/exhaustive-deps
  // lint-td: has missing dependencies: 'tenant.id' and 'user.id'
}

export function useSkipEvent(skip, payload, event) {
  const [user, tenant] = useWithUserAndTenant();
  const [status, setStatus] = useState(false);

  let subscription$;
  useEffect(() => {
    const canProceed = skip && user && tenant;
    if (canProceed) {
      // eslint-disable-next-line react-hooks/exhaustive-deps
      subscription$ = postAnalytic(
        // lint-td: Assignments to the 'subscription$' variable from inside React Hook useEffect will be lost after each render. To preserve the value over time, store it in a useRef Hook and keep the mutable value in the '.current' property. Otherwise, you can move this variable directly inside useEffect
        {
          data: payload,
          event_date: Date.now(),
          tenant_id: tenant.id,
          user_id: user.id,
        },
        event
      ).subscribe((_) => {
        setStatus(true);
      }, handleError);
    }
    return () => subscription$ && subscription$.unsubscribe();
  }, [skip, user, tenant, payload, event]);

  return status;
}
